import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Tmpru from '../assets/img/tmpru.png';
import Trucky from '../assets/img/truckway.png';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { FaAward, FaHandshake } from 'react-icons/fa';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Partners = () => {
    const { t } = useTranslation();
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const partnersRef = useScrollAnimation(0.2);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                const response = await fetch('https://hub.mileageriot.com/api/partners');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const json = await response.json();
                setPartners(Array.isArray(json) ? json : []);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching partners:', error);
                setError('Failed to load partners');
                setLoading(false);
            }
        };

        fetchPartners();
    }, []);

    const renderCarousel = () => {
        if (partners && partners.length > 0) {
            return (
                <OwlCarousel
                    className='owl-theme partners-carousel'
                    loop
                    margin={30}
                    dots={false}
                    autoplay={true}
                    autoplaySpeed={500}
                    autoplayHoverPause={true}
                    responsive={{
                        0: {
                            items: 1
                        },
                        600: {
                            items: 3
                        },
                        1000: {
                            items: 5
                        }
                    }}
                >
                    {partners.map((partner) => (
                        <div className="item" key={partner.id}>
                            <Link to={partner.url} target="_blank" rel="noopener noreferrer">
                                <div className="partner-card glass-container">
                                    <img 
                                        src={partner.logo} 
                                        className="partner-logo" 
                                        alt={partner.name} 
                                    />
                                    <div className="partner-overlay">
                                        <span className="partner-name">{partner.name}</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </OwlCarousel>
            );
        }
        return null;
    };

    return (
        <section className="partners-modern py-5" id="partners" ref={partnersRef}>
            <div className="container">
                {/* Cooperation Section */}
                <div className="section-header text-center mb-5 fade-in-up">
                    <div className="section-badge">
                        <FaHandshake className="me-2" />
                        <span className="text-primary">Мы сотрудничаем с</span>
                    </div>
                    <h2 className="section-title text-glow text-white mb-4">
                        Мы сотрудничаем с
                    </h2>
                    <div className="section-decoration"></div>
                </div>
                
                <div className="row mt-5 mx-auto fade-in-up stagger-2">
                    <div className="col-md-6 mx-auto mb-4">
                        <Link to="https://www.youtube.com/@truckwayets2" target="_blank" rel="noopener noreferrer">
                            <div className="cooperation-card glass-container">
                                <img src={Trucky} className="cooperation-logo" alt="Trucky" />
                                <div className="cooperation-overlay">
                                    <span className="cooperation-name">TruckWay</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="col-md-6 mx-auto mb-4">
                        <Link to="https://vk.com/tmpru" target="_blank" rel="noopener noreferrer">
                            <div className="cooperation-card glass-container">
                                <img src={Tmpru} className="cooperation-logo" alt="Tmpru" />
                                <div className="cooperation-overlay">
                                    <span className="cooperation-name">TMP RU</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            
            {/* Partners Section */}
            <div className="container mt-5">
                <div className="section-header text-center mb-5 fade-in-up stagger-3">
                    <div className="section-badge">
                        <FaAward className="me-2" />
                        <span className="text-primary">Наши партнёры</span>
                    </div>
                    <h2 className="section-title text-glow text-white mb-4">
                        Наши партнёры
                    </h2>
                    <div className="section-decoration"></div>
                </div>
                
                <div className="partners-carousel-container fade-in-up stagger-4">
                    {loading && (
                        <div className="text-center text-white">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2 text-white-50">Загрузка партнёров...</p>
                        </div>
                    )}
                    {error && (
                        <div className="text-center">
                            <p className="text-danger">{error}</p>
                        </div>
                    )}
                    {!loading && !error && renderCarousel()}
                </div>
            </div>
            
            {/* Background decoration */}
            <div className="section-bg-decoration"></div>
        </section>
    );
};

export default Partners;